export type RequestOutcome = 'mocked' | 'recorded' | 'passthrough';

export interface RequestLogEntry {
  id: string;
  ts: number;
  method: string;
  url: string;
  status: number;
  outcome: RequestOutcome;
  bodyText?: string;
  bodyOmitted?: boolean;
}

export class RequestLog {
  private entries: RequestLogEntry[] = [];

  constructor(
    private readonly capacity = 100,
    private readonly maxBodyBytes = 512 * 1024,
  ) {}

  push(entry: RequestLogEntry): void {
    const stored: RequestLogEntry =
      entry.bodyText !== undefined && entry.bodyText.length > this.maxBodyBytes
        ? { ...entry, bodyText: undefined, bodyOmitted: true }
        : entry;
    this.entries.push(stored);
    if (this.entries.length > this.capacity) {
      this.entries.shift();
    }
  }

  list(): RequestLogEntry[] {
    return [...this.entries].reverse();
  }

  get(id: string): RequestLogEntry | undefined {
    return this.entries.find(e => e.id === id);
  }

  clear(): void {
    this.entries = [];
  }
}
